import axios from "./axios";

export async function fetchEvents(controller) {
  return axios({ method: "get", url: "/events", params: controller });
}

export async function createEvent(payload) {
  return axios.post(`/events`, { event: payload });
}

export async function updateEvent(payload) {
  return axios.put(`/events/${payload.id}`, { event: payload });
}

export async function fetchEvent(payload) {
  return axios.get(`/events/${payload}`);
}

export async function deleteEvent(payload) {
  return axios.delete(`/events/${payload}`);
}
